import React from 'react';
import Konva from 'konva'
import { Line, Stage, Layer } from 'react-konva'
import { Grid, Divider, Avatar } from '@material-ui/core';
import Utils from '../providers/Utils';
import PropTypes from 'prop-types'
import Ws from '../providers/Ws';
import DrepturiAcces from '../module/drepturiacces/DrepturiAcces';
import SpecificComponent from './SpecificComponent';
import LocalStorage from '../providers/LocalStorage';

import { ReactComponent as Archive } from '../Pics/iconsManagement/archive.svg';
import { ReactComponent as Trash } from '../Pics/iconsManagementUtilizatori/Trash.svg';

export default class GanttProiecteMonthView extends SpecificComponent {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    // window.onresize= ()=>{document.location.reload()}
    this.listProiecte()
  }

  drepturi = new DrepturiAcces()
  ws = new Ws()
  ls = new LocalStorage().GetUserData()
  goToProiect = (p) => {

    // console.log('p :', p);
    // console.log('object :', this.props.idproiect)

    if (this.props.idUser) {
      if (this.props.idProiect[0].id === 'infoUser') {
        this.props.history.push(`/useretape/${this.props.idUser}/${p.id}`)
      } else {
        this.props.history.push(`/infouser/${this.props.idUser}`)
      }
    } else {
      if (this.props.idProiect[0].id === 'abc') {

        this.props.history.push(`/projectdetails/${p.id}/1`)
      }


      else {
        this.props.history.push(`/projects`)
      }
    }
  }


  getDate = (dt) => {

    let u = new Utils();

    if (this.props.dictionary.date === ' en') {
      return u.dataPrescurtataEng(dt)
    } else {
      return u.dataPrescurtataRomana(dt)
    }
  }

  getProiectColor = (lE, p) => {

    if (lE.length > 0) {
      return 'transparent'
    } else if (new Date(p.perioada_panala) < new Date()) {
      return '#ff3f3f'
    } else if (new Date(p.perioada_panala) > new Date() && new Date(p.perioada_dela) < new Date()) {
      return 'rgb(58, 180, 209)'
    } else {
      return 'rgb(251, 141, 0)'
    }

  }


  numeAvatar = (nume) => {

    if (nume) {
      let n = nume.split(' ')

      // console.log('n :>> ', n);

      let firstLetters = ''

      if (n[0]) {

        firstLetters += n[0].substring(0, 1)

      }
      if (n[1]) {
        firstLetters += n[1].substring(0, 1)
      }

      firstLetters = firstLetters.toUpperCase()

      return firstLetters
    } else {
      return 'NA'
    }


  }


  listProiecte = () => {
    let listProiecte = this.props.listProiecte
    let listEtape = this.props.listEtape



    // console.log('listProiecte :', listProiecte);
    // console.log('listEtape', listEtape)

    let counter = listProiecte.length

    let container = []




    for (let i = 0; i < counter; i++) {

      let filterEtape = listEtape.filter(e => e.id_proiect === listProiecte[i].id)

      let counter2 = filterEtape.length

      let dataStart = new Date(listProiecte[i].perioada_dela)
      let dataFinish = new Date(listProiecte[i].perioada_panala)

      let full = dataFinish.getTime() - dataStart.getTime()

      let defaultDate = new Date()

      let procent = 0

      let marginEtapa = 0

      for (let j = 0; j < counter2; j++) {



        let dataSfEtapa = new Date(filterEtape[j].durata_pana_la)



        let suma = dataSfEtapa.getTime() - dataStart.getTime()

        let newProcent = Math.floor((suma / full) * 100)

        if (j === counter2 - 1) {

          // console.log('newProcent :', newProcent);

          newProcent = 100
        }

        filterEtape[j].procent = newProcent - procent

        procent = newProcent
      }


      let procentProiect = 0

      // console.log('dataFinish :', dataFinish);

      let marginLeft = 0



      if (dataStart < defaultDate) {


        if (defaultDate < dataFinish) {
          let today = defaultDate.getTime() - dataStart.getTime()

          procentProiect = Math.floor((today / full) * 100)


          // console.log('procentProiect :', procentProiect);


          if (procentProiect > 50) {
            procentProiect = 100 - (procentProiect - 50)

          } else {

            marginLeft = 50 - procentProiect
            procentProiect = 100 - marginLeft
          }




          // console.log('marginLeft :', marginLeft);
        }
        else {
          procentProiect = 50
        }

      } else {
        procentProiect = 40
        marginLeft = 55
      }



      // console.log('this.props.idProiect :', this.props.idProiect);


      // console.log('filterEtape :', filterEtape);

      console.log('listProiecte[i] :>> ', listProiecte[i]);



      if (this.props.listView) {
        container.push(
          <Grid key={i} item xs={12} sm={12} md={4} lg={4} xl={4} >
            <Grid className='pm-proiect-shadow' container style={{ width: '90%', height: '100%', minHeight: 100, margin: 'auto', backgroundColor: 'white', marginBottom: 5 }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <h4 className='pm-title' style={{ textAlign: 'center', paddingLeft: 25, fontSize: 20, fontWeight: 500 }}>{listProiecte[i].titlu}</h4>
              </Grid>
              <Grid onClick={() => { this.goToProiect(listProiecte[i]) }} style={{ minHeight: 65, margin: 'auto', cursor: 'pointer', maxWidth: '97%' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                <div style={{
                  width: `100%`,
                  height: 50,
                  margin: 'auto',
                  boxSizing: 'border-box',
                  position: 'relative',
                  backgroundColor: this.getProiectColor(filterEtape, listProiecte[i]),
                  borderRadius: 30,
                  textAlign: 'left',
                  display: 'flex'
                }}>
                  <span style={{ position: 'absolute', fontSize: 13, color: '#7e7979', top: -22 }}>{this.getDate(listProiecte[i].perioada_dela)}</span>
                  <span style={{ position: 'absolute', fontSize: 13, color: '#7e7979', top: -22, right: 0 }}>{this.getDate(listProiecte[i].perioada_panala)}</span>

                  {filterEtape.map((e, idx) => {
                    return (
                      <div key={`etapa${idx}`} className={this.props.idProiect[0].id === e.id_proiect ? 'pm-selected-project-shadow' : ''} style={{
                        boxSizing: 'border-box',
                        marginLeft: `${marginEtapa}%`,

                        height: '100%',
                        width: e.procent + '%',
                        backgroundColor: e.color,
                        display: 'inline-block',
                        borderRight: idx === filterEtape.length - 1 ? '' : '1px solid #f3ebeb',
                        borderBottomLeftRadius: idx === 0 ? 30 : 0,
                        borderTopLeftRadius: idx === 0 ? 30 : 0,
                        borderBottomRightRadius: idx === filterEtape.length - 1 ? 30 : 0,
                        borderTopRightRadius: idx === filterEtape.length - 1 ? 30 : 0
                      }}>
                        <span className='pm-proiect-integral-etapa-nume' >{e.denumire}</span>
                      </div>
                    )

                  })}

                </div>
              </Grid>
              <Divider className='pm-divider' />

            </Grid>

          </Grid>

        )

      } else {

        container.push(
          <Grid style={{ margin: '10px 0 10px 0' }} key={i} item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid
              // className='pm-proiect-shadow' 
              container style={{ width: '95%', height: '100%', minHeight: 100, margin: 'auto', backgroundColor: 'white', marginBottom: 5 }}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Grid container>
                  <Grid item xs={10} sm={10} md={10} lg={10} xl={10} >
                    <h4 className='pm-title' style={{ textAlign: 'left', paddingLeft: 20, fontSize: 18, fontWeight: 700, color: 'black' }}>
                      {listProiecte[i].titlu.length > 50 ? listProiecte[i].titlu.substring(0, 50) : listProiecte[i].titlu}

                    </h4>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <span style={{ fontSize: 10 }}>{this.dictionary.proiecte.complete}</span>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <span style={{ fontSize: 14, fontWeight: 700 }}>{listProiecte[i].procent_completare}</span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
              <Grid onClick={() => { this.goToProiect(listProiecte[i]) }} style={{ minHeight: 65, margin: 'auto', cursor: 'pointer', maxWidth: '97%' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                <div style={{
                  width: `100%`,
                  height: 50,
                  margin: 'auto',
                  boxSizing: 'border-box',
                  position: 'relative',
                  backgroundColor: this.getProiectColor(filterEtape, listProiecte[i]),
                  borderRadius: 30,
                  textAlign: 'left',
                  display: 'flex',

                }}>
                  <span style={{ position: 'absolute', fontSize: 13, color: 'black', top: -22, left: 12 }}>{this.getDate(listProiecte[i].perioada_dela)}</span>
                  <span style={{ position: 'absolute', fontSize: 13, color: 'black', top: -22, right: 16 }}>{this.getDate(listProiecte[i].perioada_panala)}</span>

                  {filterEtape.map((e, idx) => {
                    if (idx < 9) {
                      return (
                        <div key={`etapa${idx}`} className={this.props.idProiect[0].id === e.id_proiect ? 'pm-selected-project-shadow' : ''} style={{
                          boxSizing: 'border-box',
                          marginLeft: `${marginEtapa}%`,
                          position: 'relative',
                          height: '100%',
                          width: e.procent + '%',
                          minWidth: 40,
                          backgroundColor: e.color,
                          display: 'inline-block',
                          borderRight: idx === filterEtape.length - 1 ? '' : '1px solid #f3ebeb',
                          borderBottomLeftRadius: idx === 0 ? 30 : 0,
                          borderTopLeftRadius: idx === 0 ? 30 : 0,
                          borderBottomRightRadius: idx === filterEtape.length - 1 ? 30 : 0,
                          borderTopRightRadius: idx === filterEtape.length - 1 ? 30 : 0
                        }}>
                          <div style={{ backgroundColor: '#ffffff57', position: 'absolute', width: (100 - e.procent_completare) + '%', height: '100%', right: 0 }}>

                          </div>
                          <span style={{ textAlign: 'center' }} className='pm-proiect-integral-etapa-nr' >{idx < 7 ? idx + 1 : (filterEtape.length > 9 ? (idx + 1) + '+' : idx + 1)}</span>
                        </div>
                      )
                    }


                  })}

                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Grid style={{ padding: 20 }} container>
                  <Grid style={{ textAlign: 'left' }} onClick={() => { this.goToProiect(listProiecte[i]) }} item xs={3} sm={3} md={3} lg={3} xl={3} >
                    <span style={{ fontWeight: 400, fontSize: 14, verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }}>{this.dictionary.proiecte.viewDetails}</span>
                  </Grid>
                  <Grid style={{ textAlign: 'right', paddingRight: 20 }} item xs={9} sm={9} md={9} lg={9} xl={9} >

                    {this.drepturi.getDrepturiAplicatie().acces_extins_proiecte &&
                      <div style={{ display: 'inline-block', marginRight: 10 }}>

                        {!this.props.hideArhiva &&

                          <Archive style={{ width: 25, height: 29, marginRight: 10, cursor: 'pointer', verticalAlign: 'super' }} onClick={() => { this.props.openArchiveProiect(listProiecte[i]) }} />

                          // <i style={{ fontSize: 30, cursor: 'pointer', marginRight: 10 }} onClick={() => { this.props.openArchiveProiect(listProiecte[i]) }} className='material-icons'>folder</i>
                        }

                        {this.props.showRedoArhiva &&

                          // <Archive style={{ width: 25, height: 29, marginRight: 10, cursor: 'pointer', verticalAlign: 'super' }} onClick={() => { this.props.openArchiveProiect(listProiecte[i]) }} />

                          <i style={{ fontSize: 30, cursor: 'pointer', marginRight: 10 }} onClick={() => { this.props.openArchiveProiect(listProiecte[i]) }} className='material-icons'>undo</i>
                        }

                        {this.ls.InfoUser.IsAdmin === 1 &&

                          <Trash style={{ width: 22, height: 29, marginRight: 10, cursor: 'pointer', verticalAlign: 'super' }} onClick={() => { this.props.openDeleteProiect(listProiecte[i]) }} />
                          // <i style={{ fontSize: 30, cursor: 'pointer' }} onClick={() => { this.props.openDeleteProiect(listProiecte[i]) }} className='material-icons'>delete</i>

                        }
                      </div>
                    }


                    {listProiecte[i].utilizatori.map((u, idx) => {



                      if (idx < 5) {

                        if (u.poza !== null) {
                          return (
                            <div key={idx} style={{ position: 'relative', width: 'fit-content', display: 'inline-block' }}>
                              <div className='etapa-tag' style={{
                                position: 'absolute', display: u.show_tag ? 'block' : 'none', top: 35,
                                left: -60, color: 'white'
                              }}>
                                <div className='user-tag-container' style={{ position: 'relative', textAlign: 'left' }}>


                                  <div style={{
                                    position: 'absolute',
                                    top: -11,
                                    left: '45%',
                                    borderBottomColor: 'rgb(75 75 75)'
                                  }} className='triangle-up'>

                                  </div>

                                  <h4 style={{ marginBottom: 5, fontSize: 14 }}>{u.nume} </h4>
                                  <span style={{ marginTop: 5, display: "block", fontSize: 12 }}>{this.dictionary.proiecte.department}:{u.nume_departament}</span>


                                </div>


                              </div>

                              <Avatar
                                onMouseEnter={() => { this.props.showUserTag(u, listProiecte[i]) }}
                                onMouseLeave={() => { this.props.hideUserTag(u, listProiecte[i]) }}
                                style={{ display: 'block', marginLeft: 10 }} src={this.ws.adresaMedia + '/Angajati/' + u.poza} />
                            </div>
                          )
                        } else {
                          return (

                            <div key={idx} style={{ position: 'relative', width: 'fit-content', display: 'inline-block' }}>
                              <div className='etapa-tag' style={{
                                position: 'absolute', display: u.show_tag ? 'block' : 'none', top: 35,
                                left: -60, color: 'white'
                              }}>
                                <div className='user-tag-container' style={{ position: 'relative', textAlign: 'left' }}>


                                  <div style={{
                                    position: 'absolute',
                                    top: -11,
                                    left: '45%',
                                    borderBottomColor: 'rgb(75 75 75)'
                                  }} className='triangle-up'>

                                  </div>

                                  <h4 style={{ marginBottom: 5, fontSize: 14 }}>{u.nume} </h4>
                                  <span style={{ marginTop: 5, display: "block", fontSize: 12 }}>Departament:{u.nume_departament}</span>


                                </div>


                              </div>
                              <Avatar
                                onMouseEnter={() => { this.props.showUserTag(u, listProiecte[i]) }}
                                onMouseLeave={() => { this.props.hideUserTag(u, listProiecte[i]) }}
                                style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, backgroundColor: new Utils().culoriUtilizatori(idx) }} key={idx}>
                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span>
                              </Avatar>


                            </div>

                          )

                        }
                      }


                    })

                    }
                  </Grid>
                </Grid>
              </Grid>


            </Grid>
          </Grid>

        )
      }



    }


    return <Grid style={{ marginBottom: 40 }} container>
      {container}
    </Grid>


  }


  render() {
    return (
      <div>
        {this.listProiecte()}
      </div>
    );
  }
}//end class


GanttProiecteMonthView.propType = {
  objPerioadaGantt: PropTypes.object,
  listEtape: PropTypes.array,
  listProiecte: PropTypes.array,
  history: PropTypes.array,
  dictionary: PropTypes.object,
  idProiect: PropTypes.number
}